import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { System } from '@/features/settings/System';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/settings/system',
  component: System,
});
